import { render, staticRenderFns } from "./BaseLoginForm.vue?vue&type=template&id=69154a62&"
import script from "./BaseLoginForm.vue?vue&type=script&lang=js&"
export * from "./BaseLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports